import React from "react";
import _ from "lodash";

import {
    Row,
    Col,
} from "reactstrap";

const FormErrorWidget = ({errors})=>{
    return(
        <Row>
            <Col xs="12">
                <div className="mlb-alert mlb-alert-primary" role="alert">
                    <Row>
                        <Col xs="1" sm="1" className="fs-42 text-danger">
                                <i className="fa fa-exclamation-triangle fa-6" aria-hidden="true"></i>    
                        </Col>
                        <Col>
                        <ul>
                            {
                                _.values(errors).map((e,i)=>{
                                    return(
                                        <li key={i}>
                                            {e}
                                        </li> 
                                    );
                                })

                            }
                            
                        </ul> 
                        </Col>
                        
                        
                    </Row>
                    
                </div>
            </Col>
        </Row>
    );
}

export default FormErrorWidget;